import { ArrowLeftOutlined } from "@ant-design/icons";
import { Button, Card, Col, message, Row, Space, Typography } from "antd";
import { AddRoleAgentModel } from "features/users/components/modals/add-role-agent";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const { Title } = Typography;

export const ManageRolePage = () => {
  const [model, setModel] = useState(false);

  const [editdata, setEditData] = useState("");
  const [PrivilegeState, setprivilegestate] = useState<any>("");
  const [roleName, SetRoleName] = useState("");
  const Navigate = useNavigate();

  // const handleRevoke = () => {
  //     setPermissions({});
  //     setprivilegestate('');
  //     SetRoleName('');
  //     setSelectedRoleId('' as any)
  // };
  const handleRevoke = () => {
    if (!PrivilegeState || PrivilegeState.length === 0) {
      message.error("Please select a role first");

      return;
    }

    // 1) Build all-false permissions for UI
    const newPermissions: any = {};

    PrivilegeState.forEach((item: any) => {
      newPermissions[item.key] = {
        add: false,
        delete: false,
        update: false,
        view: false,
        print: false,
        enable: false,
      };
    });

    // Update UI

    // 2) Build payload for API

    // 3) Send revoke-all to API

    // 4) Reset selected role UI
    setprivilegestate("");
    SetRoleName("");
  };

  const handlePrivilege = () => {
    try {
      if (!PrivilegeState) {
        message.error("Please select a role");

        return;
      }
    } catch (error) {
      console.error(error);
    }
  };
  const handleGrantAll = () => {
    if (!PrivilegeState || PrivilegeState.length === 0) {
      message.error("Please select a role first");

      return;
    }

    // 1) Build full true permissions
    const newPermissions: any = {};

    PrivilegeState.forEach((item: any) => {
      newPermissions[item.key] = {
        add: true,
        delete: true,
        update: true,
        view: true,
        print: true,
        enable: true,
      };
    });

    // 2) Update UI

    // 3) Prepare payload for API

    // 4) Call same API
  };

  return (
    <div>
      <div className="assign_head">
        <button
          onClick={() => Navigate("/users/admin")}
          style={{
            cursor: "pointer",
            border: "none",
            background: "transparent",
          }}
        >
          <ArrowLeftOutlined size={20} />
        </button>
        <Title level={4} style={{ marginBottom: 0 }}>
          Assign Role
        </Title>
      </div>

      <Row gutter={[24, 24]}>
        <Col xs={24} md={8} lg={6}>
          <Card
            title="Role List"
            bordered={false}
            extra={
              <Button type="primary" onClick={() => setModel(true)}>
                Add Role
              </Button>
            }
          ></Card>
        </Col>

        <Col xs={24} md={16} lg={18}>
          <Card
            title={roleName || "Set Role & Permissions"}
            bordered={false}
            extra={
              <Space>
                <Button type="primary" onClick={() => handlePrivilege()}>
                  Save Privilege
                </Button>
                <Button onClick={() => handleGrantAll()}>Grant All</Button>
                <Button danger onClick={handleRevoke}>
                  Revoke
                </Button>
              </Space>
            }
          ></Card>
        </Col>

        {/* MODAL */}
        {model && (
          <AddRoleAgentModel
            model={model}
            setModel={setModel}
            editdata={editdata}
            setEditData={setEditData}
          />
        )}
      </Row>
    </div>
  );
};
